module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":{"label":"Email","placeholder":"Email address"},"phone":{"label":"Phone","placeholder":"Phone number"},"name":{"label":"Name","placeholder":"Name"},"cancel":"Cancel","send":"Send"}}')
  delete Component.options._Ctor
}
